/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { Typography } from '@material-ui/core';
import {
  PlayCircleFilled as PlayIcon,
  RemoveRedEye as EyeIcon,
} from '@material-ui/icons';
import defaultThumbnail from '@assets/images/default-thumb.jpeg';
import numberWithCommas from '@shared/utils/NumberWithCommas';
import './HomeLiveStreamCard.css';

function HomeLiveStreamCard({ liveStream, navigateToProfilePage }) {
  return (
    <>
      <div
        className='livestream-card-body link-cursor'
        onClick={() => navigateToProfilePage(liveStream.username)}
      >
        <span className='livestream-card-body-hover'>
          <PlayIcon className='play-icon' />
        </span>
        <img
          className='livestream-card-body-cover'
          src={liveStream.cover_image}
          alt='livestream-cover'
          loading='lazy'
        />
        <img
          className='livestream-card-body-thumbnail'
          src={defaultThumbnail}
          alt='default-thumbnail'
          loading='lazy'
        />
        <div className='livestream-viewers-status'>
          <EyeIcon className='eye-icon' />
          <Typography>{numberWithCommas(liveStream.audience_count)}</Typography>
        </div>
        <div className='livestream-live-label'>LIVE</div>
      </div>
      <div className='livestream-card-footer'>
        <span className='livestream-title text-truncate link-cursor' onClick={() => navigateToProfilePage(liveStream.username)}>{liveStream.title}</span>
        <span className='livestream-title text-truncate livestream-username link-cursor' onClick={() => navigateToProfilePage(liveStream.username)}>{liveStream.username}</span>
      </div>
    </>
  );
}

export default HomeLiveStreamCard;
